import { Box } from '@mui/material';
import { Typography, colors } from '@leapeasy/ui-kit';

export const DetailsItem = ({ label, value, isLastItem = false }) => {
  const valueText = value == null ? '' : String(value);

  return (
    <Box
      flexGrow={1}
      flexBasis={0}
      minWidth={0}
      maxWidth="100%"
      fontWeight={500}
      px={1}
      overflow="hidden"
      borderRight={!isLastItem && `1px solid ${colors.purple[200]}`}
    >
      <Box width="100%" maxWidth="100%" overflow="hidden">
        <Typography
          variant="body3"
          style={{
            color: colors.black[600],
            marginBottom: 8,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {label}
        </Typography>
        <Typography
          variant="body3"
          title={valueText || undefined}
          style={{
            color: colors.purple[900],
            display: 'block',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {value}
        </Typography>
      </Box>
    </Box>
  );
};
